
<!-- <img class="right-oval" src="assets/img/ovals/grey-oval-right.png"/> -->

<ion-content>

  <ion-menu-toggle class="SCWEB-menu-icon">
    <ion-button color="white">
      <img src="assets/img/shortcut-icon.png" class="SCWEB-menu-img" />
    </ion-button>
  </ion-menu-toggle>

  <div class="SCWEB-address-container">
    <mat-form-field (click)="picker.open()">

      <mat-label>Select dates</mat-label>
      <mat-date-range-input [min]="startOf2020" [max]="yesterday" [rangePicker]="picker">
        <input style="cursor: pointer" matStartDate placeholder="Start date" [ngModel]="startDate" (dateChange)="startDateChanged(undefined, $event)">
        <input style="cursor: pointer" matEndDate placeholder="End date" [ngModel]="endDate" (dateChange)="endDateChanged(undefined, $event)">
      </mat-date-range-input>

      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-date-range-picker #picker></mat-date-range-picker>

    </mat-form-field>
  </div>

  <div class="top-section">
    <h2 class="section-header">{{userService.business ? userService.business.name : ''}}</h2>
    <p class="section-subtitle">Earnings summary for period</p>

    <div class="loading-container" *ngIf="!overallAnalytics">
      <ion-spinner></ion-spinner>
    </div>

    <div *ngIf="overallAnalytics" class="analytics-wrapper">

      <h2 class="earnings-number green">{{formatCost(overallAnalytics.revenueTotal, overallAnalytics.currency)}}</h2>
      <p class="earnings-subtitle">GROSS REVENUE FROM {{overallAnalytics.numAppts}} APPOINTMENTS</p>

      <h2 class="earnings-number">{{formatCost(overallAnalytics.businessCommissionTotal, overallAnalytics.currency)}}</h2>
      <p class="earnings-subtitle">NET EARNINGS</p>

    <p class="open-pdf-button" (click)="downloadProPaymentsPdf()">
      <ion-icon name="cloud-download-outline"></ion-icon>
      Download Pro Payments for period
    </p>

    </div>
  </div>

  <div class="bottom-section">
    <h2 class="section-header">Summary by Pro</h2>
    <p class="section-subtitle">{{getDate(startDate)}} - {{getDate(endDate)}}</p>

    <div class="loading-container" *ngIf="!proSummaries">
      <ion-spinner></ion-spinner>
    </div>

    <div *ngFor="let a of proSummaries">

      <div class="pro-analytics-wrapper">

        <div class="pro-name-section">
          <span class="pro-name" (click)="goToPro(a.info.link)">{{a.info.fullName}}</span>
          <span class="pro-status" [ngStyle]="{'color': getProStatus(a).color}">
            <span class="pro-status-dot">•</span>
            {{getProStatus(a).status}}
          </span>
          <p class="pro-protype">{{a.info.proType}} Pro</p>
        </div>

        <div class="pro-image-earnings-section">
          <ion-row>
            <ion-col size="3" class="pro-pic-col">
              <div class="pic-wrapper">
                <img class="pro-pic" [src]="a.info.pic || placeholderImg"/>
              </div>
            </ion-col>
            <ion-col size="9" class="pro-info-col">
              <p class="datapoint"><span class="data-number">{{formatCost(a.earnings, a.info.currency)}}</span> | Pro commission in period.</p>
              <p class="datapoint"><span class="data-number">{{formatCost(a.tips, a.info.currency)}}</span> | Tips sent in period.</p>
              <p class="datapoint"><span class="data-number">{{a.numAppts}}</span> | Appointments completed.</p>
              <p class="datapoint"><span class="data-number">{{a.numHoursWorked || 0}}</span> | Hours working and traveling.</p>
            </ion-col>
          </ion-row>
        </div>

        <!-- <div class="bottom-buttons">
          <p class="bottom-button" (click)="viewBookkeepingForPro(a.info.id)">View all data</p>
          <ion-icon name="arrow-redo-circle-outline"></ion-icon>
        </div> -->

      </div>
    </div>
  </div>

</ion-content>

<ion-footer slot="fixed" class="SC-support-footer">
  <span class="support-button" (click)="openPage('https://getshortcut.co/faq')">FAQ</span>
  <span class="support-button" (click)="adminChat()">Live chat</span>
  <span class="support-button" (click)="openPage('https://getshortcut.co/privacy')">Privacy policy</span>
  <span class="support-button" (click)="openPage('https://getshortcut.co/terms')">Terms of service</span>
</ion-footer>